<template>
  <div class="page">
    <div v-if="model != null">
      <van-panel class="panel-info">
        <van-cell
            slot="header"
            title="审核信息状态"
            icon="orders-o"
        >
          <van-tag v-if="model.status == 0"
          >待审核</van-tag
          >
          <van-tag v-else-if="model.status == 1" type="success"
          >已通过</van-tag
          >
          <van-tag v-else-if="model.status == 2" type="danger"
          >未通过</van-tag
          >
        </van-cell>
        <div class="content">
          <div class="row">
            <span class="label">技能名称</span>
            <span class="value">{{ model.categoryName }}</span>
          </div>
          <div v-if="model.grade && model.grade != null" class="row">
            <span class="label">技能等级</span>
            <span class="value">{{$store.state.ClerkGradeMap[model.grade]}}</span>
          </div>
          <div class="row">
            <span class="label">技能图标</span>
            <VanImage style="margin-right:2%"
                       width="40"
                       height="40"
                       fit="contain"
                       :src="model.iconUrl"
                       @click="HandleclickImg(model.iconUrl, 0, false)"/>
          </div>
          <div class="row">
            <span class="label">取消时间</span>
            <span class="value">{{
                formatDate(model.createTime, "YYYY-MM-DD HH:mm:ss")
              }}</span>
          </div>
          <div  v-for="(item, index) in model.content" :key="index">
            <div class="cellBox row" v-if="item.type == 'text'">
              <span class="label">{{item.title}}</span>
              <span class="value">{{item.textValue}}</span>
            </div>
            <div class="row" v-if="item.type == 'video'">
              <span class="label">{{item.title}}</span>
              <span class="value">
                  <video width="100%" height="200px" :src="item.localVideo" controls="controls" @play="handlePlay(item.videoIndex)"></video>
                </span>
            </div>
            <div class="row" v-if="item.type == 'picture'">
              <span class="label">{{item.title}}</span>
              <span class="value">
                <VanImage v-for="(img,index) in item.photoUrls"
                          :key="index"
                          style="margin-right:2%"
                          width="40"
                          height="40"
                          fit="contain"
                          :src="img"
                          @click="HandleclickImg(item.photoUrls,index, true)" />
              </span>
            </div>
            <div class="row" v-if="item.type == 'audio'">
              <span class="label">{{item.title}}</span>
              <span class="value">
                <div class="audio-player" :class="player.id != null && player.id == item.audioIndex ? 'playing' : ''"
                   @click.prevent.stop="playAudio(item.audioIndex, item.audio)">
                <div class="audio">
                  <div class="play-tubiao align-center"><van-icon :name="player.id != null && player.id == item.audioIndex ? 'pause' : 'play'" class="play-a"/></div>
                  <img class="wave" src="/static/images/19/play.png" width="10">
                </div>
              </div>
              </span>
            </div>
          </div>
        </div>
      </van-panel>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Button,
  CellGroup,
  Cell,
  Icon,
  Dialog,
  Toast,
  Image as VanImage,
  ImagePreview,
  Panel,
  Tag
} from "vant";
import {getCategoryExamineCheck} from '@/api/clerk/category_examine_check'
import moment from "moment";


Vue.use(Button)
    .use(VanImage)
    .use(Panel)
    .use(Tag)
    .use(CellGroup)
    .use(Cell)
    .use(Icon)
    .use(Dialog)
    .use(Toast)
    .use(ImagePreview);

export default {
  name: "category-examine-apply-detail",
  components: {
  },
  data() {
    return {
      model: null,
      videoElement: [],
      player: {
        id: null,
        audio: null
      }
    };
  },
  computed: {},
  watch: {
  },
  methods: {
    handlePlay (index) {
      if (this.player.audio != null) {
        this.player.audio.pause()
        this.player = {
          id: null,
          audio: null
        }
      }
      const videoElement = this.videoElement
      if (videoElement && videoElement.length > 0) {
        for (let i = 0; i < videoElement.length; i++) {
          if ( i === index) {
            this.videoElement[i].play()
          } else {
            this.videoElement[i].pause()
          }
        }
      }
    },
    HandleclickImg(photoUrl, index, isMore){
      if (isMore) {
        ImagePreview({
          images: photoUrl,
          startPosition: index,
        });
      } else {
        let arr = new Array()
        arr.push(photoUrl)
        ImagePreview({
          images: arr,
          startPosition: index,
        });
      }
    },
    formatDate(date, format) {
      if (!date) {
        return "";
      }
      if (!format) {
        format = "YYYY-MM-DD";
      }
      return moment(date).format(format);
    },
    loadData() {
      // 获取审核信息详情
      Toast.loading({
        mask: true,
        duration: 0
      })
      getCategoryExamineCheck(this.$route.params.id).then(res => {
        Toast.clear()
        let data = res.data
        if (data.code == 0) {
          this.model = data.examineCheck ? data.examineCheck : null
        } else {
          Dialog.alert({
            title: '加载技能申请信息失败',
            message: data.msg
          })
        }
      })
      this.videoElement = document.getElementsByTagName('video')
    },
    // 播放录音
    playAudio(id, audioUrl) {
      if (this.player.audio != null) {
        this.player.audio.pause()
      }
      if (this.player.id == id) {
        this.player.id = null
        this.player.audio = null
      } else {
        const videoElement = this.videoElement
        for (let i = 0; i < videoElement.length; i++) {
          this.videoElement[i].pause()
        }
        const audio = new Audio(audioUrl)
        audio.play()
        // 播放结束事件
        audio.onended = () => {
          this.player.id = null
          this.player.audio = null
        }
        this.player.id = id
        this.player.audio = audio
      }
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>
<style lang="less" scoped>
.page {
  padding-bottom: 100px;

  .panel-info {
    margin-top: 10px;

    .content {
      font-size: 14px;
      padding: 10px 15px;

      .row {
        .user_head {
          position: relative;
          padding: 10px;
          .level {
            position: absolute;
            left: 50%;
            height: 10px;
            font-size: 10px;
            white-space: nowrap;
            bottom: 5px;
            transform: translateX(-50%);
          }

          .avatarFrame {
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
    }
  }

  .row {
    display: flex;
    color: #333;
    margin: 10px 0;
    align-items: center;
  }

  .label {
    width: 80px;
    color: #888;
  }

  .value {
    flex: 1;
  }

  .bottom-bar {
    padding: 10px 15px;
    /*background: #fff;*/
    /*box-shadow: 0 0 3px 0px #333;*/
    /*position: fixed;*/
    /*bottom: 0;*/
    /*left: 0;*/
    /*right: 0;*/
  }

  .commentBox {
    width: 100%;
    background: #fff;
    padding: 15px;
    margin-top: 20px;
    box-sizing: border-box;
  }

  .imgStyle {
    margin-left: 10px;
    flex: 0 0 15%;
    height: 0;
    padding-bottom: 15%;
    overflow: hidden;
    position: relative;
  }

  .screenshot {
    width: 100%;
    display: flex;
    align-content: flex-start;
    flex-flow: row wrap;
  }

  .screenshotImg {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .module {
    margin-top: 15px;
    padding: 0px 15px;
    position: relative;

    /deep/ .van-cell {
      padding: 15px 0;
      background: transparent;
      font-size: 14px;
      line-height: 20px;
      font-family: PingFangSC-Regular, PingFang SC;

      &.module-title {
        padding-bottom: 0;
      }

      .van-cell__title {
        width: 90px;
        flex: none;
        box-sizing: border-box;
        font-weight: 600;
        color: #333333;
      }

      .van-cell__value {
        font-weight: 400;
        color: #999999;
      }

      &.van-cell--required {
        &::before {
          left: 0px;
        }
      }
    }
  }

  .image-uploader {
    /deep/ .van-uploader__wrapper {
      .van-uploader__preview {
        .van-uploader__preview-delete {
          top: 0;
          right: 0;
          color: var(--primary-color);
        }
      }
    }
  }
  .wx {
    height: 20px;
    line-height: 18px;
    background-color: #f87d23;
    border: 1px solid #f87d23;
    margin-right: 15px
  }

}

.audio-player {
  width: 50%;
  height: 25px;
  background: #54D3C3;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 9px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background-size: cover;
  z-index: 3;

  .audio {
    width: 100%;
    padding: 0 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .wave {
      margin-left: 3px;
    }

    .duration {
      font-size: 8px;
      font-weight: 500;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #fff;
    }
  }

  &.playing {
    .wave {
      @keyframes wave {
        from {
          height: 18px;
        }
        to {
          height: 12px;
        }
      }
      animation: wave .5s linear 0s infinite alternate;
    }
  }
}
.play-tubiao{
  width: 14px;
  line-height: 14px;
  font-size: 6px;
  text-align: center;
}
.play-a{
  color: #fff;
  vertical-align: middle;
}
</style>
